// @flow
import { fetchOrg as apiFetchOrg } from 'api/orgs';
import type { Org } from 'api/orgs';
import type { Dispatch, GetState } from '..';
import { setError } from './error';

type FetchOrgRequestAction = {
  type: 'FETCH_ORG_REQUEST',
  orgId: string
};
type FetchOrgSuccessAction = {
  type: 'FETCH_ORG_SUCCESS',
  org: Org
};
type PartialUpdateOrgAction = {
  type: 'PARTIAL_UPDATE_ORG',
  values: Object
};

export type Action =
  | FetchOrgRequestAction
  | FetchOrgSuccessAction
  | PartialUpdateOrgAction;

const fetchOrgRequest = (orgId: string): FetchOrgRequestAction => ({
  type: 'FETCH_ORG_REQUEST',
  orgId
});

const fetchOrgSuccess = (org: Org): FetchOrgSuccessAction => ({
  type: 'FETCH_ORG_SUCCESS',
  org
});

export const fetchOrg = (orgId: string) => (
  dispatch: Dispatch,
  getState: GetState
) => {
  const state = getState();
  const org = state.orgs.byId[orgId];
  if (!org) {
    dispatch(fetchOrgRequest(orgId));
    apiFetchOrg(orgId)
      .then(fetchedOrg => {
        dispatch(fetchOrgSuccess(fetchedOrg));
      })
      .catch(e => {
        dispatch(setError(e));
      });
  }
};

export const updateOrg = fetchOrgSuccess;

export const partialUpdateOrg = (values: Object): PartialUpdateOrgAction => ({
  type: 'PARTIAL_UPDATE_ORG',
  values
});
